export default "__VITE_ASSET__DduEJStU__"